// Canonical Shopify storefront URLs for each AFRQA product slug.
// Purchases are completed on Shopify; AFRQA.com is the editorial storefront.
//
// IMPORTANT: We link to the raw `.myshopify.com` host (NOT the custom afrqa.com
// domain) because the AFRQA React app is served at afrqa.com/* and its
// catch-all route intercepts /products/* paths. The `_ab=0&_fd=0&_sc=1`
// query params instruct Shopify to skip the "primary domain" 301 redirect
// so the user actually lands on the Shopify-hosted product page instead of
// looping back to the editorial site.
const SHOPIFY_HOST = "https://mimi1r-2n.myshopify.com";
const SHOPIFY_BYPASS_PARAMS = "?_ab=0&_fd=0&_sc=1";

export const SHOPIFY_PRODUCT_URLS = {
  "africa-frame": `${SHOPIFY_HOST}/products/afrqa-africa-shaped-glasses${SHOPIFY_BYPASS_PARAMS}`,
};

export const getShopifyUrl = (slug) => SHOPIFY_PRODUCT_URLS[slug] || null;

// Default purchase link used by global CTAs (Header, Hero, Featured, Scarcity, Vision).
export const PRIMARY_SHOPIFY_URL = SHOPIFY_PRODUCT_URLS["africa-frame"];
